import React from "react";
import PropTypes from "prop-types";
import { CommandBarButton, IconButton } from "@fluentui/react";
import DetailsTable from "../../../../Table/DetailsTable";

const ActionPlanAnalysisTable = ({
    analyses,
    setSelectedAnalysisId,
    loading,
    deleteOnClick,
    editOnClick,
    createOnClick,
    createDisabled
}) => {
    const columns = [
        {
            key: "column1",
            name: "ID",
            fieldName: "crsapAnalysisID",
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
        },
        {
            key: "column2",
            name: "Order",
            fieldName: "orderNumber",
            minWidth: 40,
            maxWidth: 40,
            isResizable: true
        },
        {
            key: "column3",
            name: "Sentence",
            fieldName: "sentence",
            minWidth: 300,
            maxWidth: 500,
            isResizable: true
        },
        {
            key: "menu",
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    item={item}
                    editOnClick={editOnClick}
                    deleteOnClick={deleteOnClick}
                />
            )
        },
        {
            key: "column4",
            name: "On Off Rule",
            fieldName: "onOffRule",
            minWidth: 150,
            maxWidth: 200,
            isResizable: true
        },
        {
            key: "column6",
            name: "On Off Default",
            fieldName: "onOffDefault",
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
        }
    ];

    const items = analyses ?? [];

    const selectionHook = (items) => {
        setSelectedAnalysisId(items && items[0] && items[0].crsapAnalysisID);
    };

    return (
        <DetailsTable
            items={items}
            columns={columns}
            selectionHook={selectionHook}
            loading={loading}
            mainColumn={"sentence"}
            style={{
                position: "relative",
                height: "80vh",
                width: "80vw",
            }}
            CommandBar={
                <CommandBarButton
                    iconProps={{ iconName: "Add" }}
                    text="Create"
                    onClick={() => createOnClick()}
                    disabled={createDisabled}
                />
            }
        />
    );
};

const moreIcon = { iconName: "More" };


// ContextualMenu moved out of parent, receives item as prop
const ContextualMenu = ({ item, editOnClick, deleteOnClick, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: "print",
                iconProps: { iconName: "Edit" },
                text: "Edit",
                onClick: () => editOnClick(item),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(item),
            }
        ],
    };

    return (
        <IconButton
            iconProps={moreIcon}
            menuProps={menuProps}
            onRenderMenuIcon={() => { }}
            {...rest}
        />
    );
};


ActionPlanAnalysisTable.propTypes = {
    analyses: PropTypes.arrayOf(PropTypes.shape({
        crsapAnalysisID: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        orderNumber: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        sentence: PropTypes.string,
        onOffRule: PropTypes.string,
        onOffDefault: PropTypes.bool
    })).isRequired,
    setSelectedAnalysisId: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    deleteOnClick: PropTypes.func.isRequired,
    editOnClick: PropTypes.func.isRequired,
    createOnClick: PropTypes.func.isRequired,
    createDisabled: PropTypes.bool
};

export default ActionPlanAnalysisTable;
